export default __webpack_public_path__ + "static/media/COM45.93c6c91f.webp";